/* VictroFIT™ Shopify Theme JS */

// ── Scroll Reveal ──
const rvEls = document.querySelectorAll('.rv,.reveal');
const rvObs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); } });
}, { threshold: 0.08 });
rvEls.forEach(el => rvObs.observe(el));

// ── FAQ ──
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ── Mobile Menu ──
function toggleMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.querySelector('.ham-btn');
  nav.classList.toggle('open');
  if (btn) btn.setAttribute('aria-expanded', nav.classList.contains('open'));
}

// ── Cart Drawer ──
function toggleCart() {
  document.getElementById('cartOverlay').classList.toggle('open');
}
function closeCartBg(e) {
  if (e.target === document.getElementById('cartOverlay')) {
    document.getElementById('cartOverlay').classList.remove('open');
  }
}

// ── Cart AJAX update ──
function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  })
  .then(r => r.json())
  .then(() => refreshCart());
}

// ── Refresh cart HTML via AJAX ──
function refreshCart() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
  .then(r => r.json())
  .then(cart => {
    // Badge
    const badge = document.getElementById('cartBadge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    // Total
    const total = document.getElementById('cartTotal');
    if (total) total.textContent = '₹' + (cart.total_price / 100).toLocaleString('en-IN');
    // States
    const empty = document.getElementById('cartEmpty');
    const items = document.getElementById('cartItems');
    const foot  = document.getElementById('cartFoot');
    if (empty) empty.style.display = cart.item_count === 0 ? 'block' : 'none';
    if (items) items.style.display = cart.item_count > 0  ? 'block' : 'none';
    if (foot)  foot.style.display  = cart.item_count > 0  ? 'block' : 'none';
    // Re-render items
    if (items && cart.items.length > 0) {
      items.innerHTML = cart.items.map(item => `
        <div class="cart-product" data-key="${item.key}">
          <div class="cart-prod-img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="cart-prod-info">
            <div class="cart-prod-name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-prod-sub">${item.variant_title}</div>` : ''}
            <div class="cart-qty-row">
              <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity - 1})">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity + 1})">+</button>
              <span class="cart-prod-price">₹${(item.final_line_price / 100).toLocaleString('en-IN')}</span>
            </div>
          </div>
        </div>
      `).join('');
    }
  });
}

// Init
refreshCart();
